(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["refundid-snippet"] && !Shopify.designMode) return;
  try {
    document.getElementById('refundid-sdk').addEventListener('load', function() {
    RefundidOnstore.init({
      // Required - CSS selector for checkout buttons
      attach: 'button[name="checkout"]',
      // Visual customization (optional)
      popupBackgroundColor: '#ffffff',
      popupTextColor: '#000000',
      popupImageUrl: '',
      // Text customization (optional)
      popupMainText: 'You have {credit} to spend',
      popupSubText: 'Use your credit to find something new and if you see more you like, you can pay the difference',
      popupButtonText: 'Start Shopping'
    });
  });
  } catch(e) { console.error(e); }
})();

})();
